(function () {
    let tlCartGoalEmbedClone;

    Object.defineProperty(window, "tlCartGoalEmbed", {
        
        get() {
            return tlCartGoalEmbedClone;
        },
        set(value) {
            if (value && !tlCartGoalEmbedClone) {

                const CUSTOM_CONFIG = (window.SALEPIFY_GIFT_IMGS || []).map(img => ({ img }));

                value.replaceVariables = (string, milestone) => {
                    const cartValue = milestone.cart_value;
                    return string
                        .replace(/{{discount}}/g, `${cartValue} 
                            ${
                                milestone.discount_type === "percentage" ?
                                    `${cartValue}%` :
                                    window.tlCartGoalEmbed.formatMoney(cartValue * 100, window.tlCartGoalEmbed.currencyFormat, window.tlCartGoalEmbed.currencyDisplay)
                            }`  
                        )
                        .replace(/{{amount}}/g, window.tlCartGoalEmbed.formatMoney((cartValue - window.tlCartGoalEmbed.cartTotal) * 100, window.tlCartGoalEmbed.currencyFormat, window.tlCartGoalEmbed.currencyDisplay))
                        .replace(/{{title}}/g, `<strong class="font-bold">${milestone.title}</strong>`)
                }

                value.getMilestoneIcon = function(milestone) {
                    const iconTypeMap = {
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_GIFT]: "free_gift",
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.CART_DISCOUNT]: "discount",
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_SHIPPING]: "shipping"
                    };

                    const fileUrl = window.tlCartGoalEmbed.icons?.[iconTypeMap[milestone.reward_type] || "free_gift"]?.url || "";
                    const isCustom = true;
                    const isSvg = false;
                    const isCustomImage = isCustom && !isSvg;

                    const index = window.tlCartGoalEmbed.milestones.findIndex(m => m.cart_value === milestone.cart_value)
                    const defaultIcon = CUSTOM_CONFIG[index]?.img || window.tlCartGoalEmbed.giftSVG;

                    const imgSrc = isCustom ? defaultIcon : fileUrl;

                    return { isCustom, isCustomImage, imgSrc };
                };

            }

            tlCartGoalEmbedClone = value;
        },
        configurable: true,
    });
})();

